/**
 * Shared brand identity constants.
 *
 * Lives here (not in `@reflecto/client-ui`) because the values are
 * pure data — no presentation, no DOM, safe to import from any
 * surface. Hosting them in `client-core` lets the extension's
 * PairingView wrapper, the web's PairingPage, and any future
 * Electron/Tauri shell all reference the same source instead of
 * re-declaring local constants that drift apart on each rotation.
 *
 * Public-facing only: anything secret (FCM keys, JWT secrets, VAPID
 * private key, etc.) belongs nowhere near this file — those are
 * deploy-time env vars on the server, not source-level constants.
 */

/**
 * User-facing support contact. Rendered as the `mailto:` target in
 * PairingView's footer help-hint and surfaceable from any future
 * "report a problem" affordance. Keep in sync with the address
 * monitored by the team.
 */
export const SUPPORT_EMAIL = "hello@reflecto.dev";
